export enum CustomerCallActionsEnum {
  undefined,
  pushCall,
  notAnswer,
  answer
}